import { LogLevels } from './Enums'

class Logger {
    constructor(logLevel) {
        this.logLevel = Object.values(LogLevels).includes(logLevel) ? logLevel : LogLevels.debug
        return (Logger.instance = Logger.instance || this)
    }

    log(message, style = '') {
        if (this.logLevel === LogLevels.debug) {
            let groupName = ''

            if (typeof message === 'object') {
                groupName = JSON.stringify(message)
            } else {
                groupName = typeof message === 'string' ? message : message.toString()
            }

            groupName = this.replaceMultilines(this.truncate(groupName, 100))

            if (style?.length) {
                console.groupCollapsed(message, style)
                console.trace('Trace:')
                console.groupEnd()
            } else {
                console.groupCollapsed(groupName)
                console.trace(message)
                console.groupEnd()
            }
        }
    }

    warn(message) {
        return this.logLevel === LogLevels.debug || this.logLevel === LogLevels.test ? console.warn(message) : false
    }

    error(message) {
        return console.error(message)
    }

    replaceMultilines(string) {
        return string.replace(/\r\n/g, ' ').replace(/\n/g, ' ')
    }
    truncate(str, n) {
        return str.length > n ? str.substr(0, n - 1) + '...' : str
    }
}

export default new Logger()
